import ReactHtmlParser from "@/src/utils/html-parser";
import SpanTypography from "@/src/mui-custom/typography/span-typography/span-typography";
import { Box, List, ListItem, ListItemText, Typography } from "@mui/material";
import type ArticleReference from "@/src/_types/Article/article-reference";
import { HEADING_SIZE } from "@/src/components/common/broadsheet/tokens";

const ArticleReferences = ({
  references,
}: {
  references: ArticleReference[];
}) => {
  if (!references) return null;

  return (
    <Box component="section" role="doc-bibliography">
      <Typography
        component="h2"
        color="textSecondary"
        sx={{ marginBlockEnd: 0, marginBottom: 0 }}
      >
        <SpanTypography sx={{
          fontSize: HEADING_SIZE.section
        }}>References</SpanTypography>
      </Typography>
      <List
        sx={{
          py: 0,
          "& a": {
            overflowWrap: "break-word",
            wordBreak: "break-all",
            paddingBlock: "4px",
          },
        }}
      >
        {references.map(
          (ref: ArticleReference) =>
            ref.ref_html &&
            ref.ref_html !== "" && (
              <ListItem
                key={ref.id}
                id={ref.id}
                sx={{
                  display: "flex",
                  alignItems: "baseline",
                  paddingTop: 0,
                  paddingBottom: 0,
                  textAlign: "justify",
                  span: {
                    fontSize: ".9rem",
                  },
                }}
              >
                <SpanTypography
                  variant="body2"
                  sx={{
                    fontStyle: "italic",
                    mr: 0.25
                  }}>
                  {ref.label}.
                </SpanTypography>
                <ListItemText>
                  <Box>{ReactHtmlParser(ref.ref_html)}</Box>
                </ListItemText>
              </ListItem>
            ),
        )}
      </List>
    </Box>
  );
};

export default ArticleReferences;
